(() => {
  'use strict';

  const LINK = '';
  const VERSION = '11';
  const WA_LINE = true;

  const BRAND = 'citydoctor';
  const SITE = BRAND + '/' + VERSION;
  const WA_NUMBER = '971551548684';
  const TEL = 'tel:8005060';
  const PHONE_LABEL = '800 50 60';
  const GOOGLE_REVIEW = 'https://search.google.com/local/writereview?placeid=ChIJgUjQUEcTXz4R2xuqe6Og_1w';
  const NOTES = 'cd-bookings', PAID = 'cd-paid', TRACK_KEY = 'cd-track-key', PICK = 'cd-after-pick', OPENED = 'cd-after-opened', WA_SEEN = 'cd-after-wa', ASKED = 'cd-after-asked';
  const HOUR = 3600000, DAY = 86400000, SENT_DAYS = 14, BOOKED_DAYS = 7, MAX_NOTES = 20, MAX_SENT = 3;
  const REF_RE = /^CD-[A-Z0-9]{8}$/, KEY_RE = /^[A-Za-z0-9_-]{22,64}$/, DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
  const STEPS = ['received', 'assigned', 'on_the_way', 'almost_there', 'arrived', 'done'];
  const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const SAMPLE_REF = 'CD-SAMPLE01';

  const W = {
    brand: 'City Doctor',
    sep: ', ',
    days: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
    months: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
    to: 'to', am: 'am', pm: 'pm', noon: 'Noon', midnight: 'Midnight',
    thanks: 'Thank you',
    bookedTitle: 'Booking Received',
    yourCode: 'Your booking code is',
    trackTitle: 'Track My Booking',
    code: 'Booking code',
    trackSub: 'See your booking and its time.',
    sampleStrong: 'Sample screen.',
    sampleRest: 'This is not a real booking.',
    visit: 'Your Visit',
    timeAsked: 'Time you asked for',
    timeYours: 'Your time',
    timeNew: 'Your new time',
    dubai: 'Dubai time',
    confirmed: 'Confirmed',
    tagNew: 'New',
    team: 'Your Team',
    and: 'and',
    copy: 'Copy',
    copyAria: 'Copy booking code {code}',
    copied: 'Booking code copied',
    copyFail: 'Your booking code is {code}',
    next: 'What Happens Next',
    next1: 'Our team checks your booking.',
    next2: 'We confirm your time on WhatsApp.',
    next3: 'We aim to arrive within your time slot.',
    wa: 'Chat on WhatsApp',
    call: 'Call {phone}',
    emergency: 'For a medical emergency, call',
    waHello: 'Hello City Doctor, my booking code is {code}.',
    waHelp: 'Hello City Doctor, I need help with my booking.',
    waPromise: 'Our team will confirm your time on WhatsApp.',
    step_received: 'Booking received',
    step_assigned: 'Team assigned',
    step_on_the_way: 'Team is on the way',
    step_almost_there: 'Almost there',
    step_arrived: 'Team has arrived',
    step_done: 'Visit done',
    now_received: 'Booking received',
    now_assigned: 'Team assigned',
    now_on_the_way: 'Team is on the way',
    now_almost_there: 'Almost there',
    now_arrived: 'Team has arrived',
    now_done: 'Thank you',
    sub_received: 'We have your booking.',
    sub_assigned: 'We have chosen your team.',
    sub_on_the_way: 'Your team is on the way to you.',
    sub_almost_there: 'Your team is close.',
    sub_arrived: 'Your team is at your address.',
    sub_done: 'Your visit is done. Tell us how it was.',
    doneSub: 'Your visit is done.',
    live: 'Live',
    visitDone: 'Visit done',
    passedNow: 'The time you asked for has passed.',
    passedSub: 'If our team has not come, message us on WhatsApp.',
    askUsNow: 'We could not read this booking.',
    askUsSub: 'Please message us on WhatsApp.',
    stepsTitle: 'Step by step',
    srDone: '(done)',
    srNow: '(now)',
    srNext: '(not yet)',
    movedTitle: 'Your visit has a new time',
    lateTitle: 'Your team is running late',
    newTime: 'New time',
    timeBefore: 'Time before',
    sorryChange: 'We are sorry for the change.',
    sorryWait: 'We are sorry for the wait.',
    tellUs: 'If this time does not suit you, tell us.',
    askTime: 'Ask for a new time',
    askCancel: 'Cancel my booking',
    day: 'Day',
    time: 'Time',
    dubaiPar: '(Dubai time)',
    keepsTime: 'Your booking keeps its time until our team confirms.',
    askSend: 'Send my request',
    back: 'Back',
    cancelTitle: 'Cancel this booking?',
    cancelLine: 'Our team will message you on WhatsApp about it.',
    cancelYes: 'Yes, ask to cancel',
    cancelNo: 'No, keep my booking',
    askGot: 'We got your request',
    askSeen: 'Our team has your request',
    askedFor: 'You asked for',
    askedTime: 'You asked for a new time.',
    askedCancel: 'You asked to cancel this booking.',
    keepsTimeWa: 'Your booking keeps its time until our team confirms on WhatsApp.',
    staysWa: 'Your booking stays until our team confirms on WhatsApp.',
    askUndo: 'Take back my request',
    askDeclined: 'Our team could not change this booking. Please call us or message us on WhatsApp.',
    askTooLate: 'Your request came too late to change this visit. Please call us or message us on WhatsApp.',
    changeNow: 'To change something now, call us or message us on WhatsApp.',
    pickTime: 'Please pick a day and a time.',
    askClosed: 'This booking cannot be changed here now. Please call or message us.',
    askAhead: 'Please pick a time that is still ahead.',
    sendFail: 'We could not send it. Please try again.',
    fbTitle: 'How was your visit?',
    fbLegend: 'Your rating, from 1 to 5 stars',
    star1: '1 star',
    starN: '{n} stars',
    fbTap: 'Tap a star.',
    fbThanks: 'Thank you. Your answer helps our team.',
    fbThanksWords: 'Thank you. Our team reads every answer.',
    fbMore: 'Tell us more',
    fbMoreOpt: '(if you like)',
    fbPlaceholder: 'What went well? What can we do better?',
    send: 'Send',
    google: 'Write a Google review',
    fbAlready: 'Thank you. Your answer is already with our team.',
    notFound: 'We could not find this booking.',
    notFoundSub: 'Please send us your booking code on WhatsApp.',
    looking: 'Looking for your booking.',
    cannotShow: 'We cannot show this booking right now.',
    cannotShowSub: 'Please try again in a moment, or message us on WhatsApp.',
    noneSaved: 'No booking is saved in this browser.',
    notHere: 'We could not find this booking in this browser.',
    checkEmail: 'If you booked, check your email for the order.',
    sendCode: 'You can also send us your booking code on WhatsApp.',
    othersTitle: 'Other bookings saved in this browser',
    savedTitle: 'Bookings saved in this browser',
    sampleEarlier: 'Earlier step',
    sampleNext: 'Next step',
    sampleStep: 'Step {n} of {all}',
    sampleCases: 'Sample case',
    caseOnTime: 'On time',
    caseMoved: 'New time',
    caseLate: 'Team is late',
    sampleNurse: 'Nurse',
    sampleName: 'Sara',
    waLine: 'By adding your number you agree to get booking updates from City Doctor on WhatsApp.'
  };

  const ICON = {
    check: 'M5 12.5l4.5 4.5L19 7.5',
    calendar: 'M7 3.5v3M17 3.5v3M4.5 9.5h15M6.5 5h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
    clock: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 7.5V12l3 2',
    heart: 'M12 19.5s-7-4.3-7-9.4A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.1c0 5.1-7 9.4-7 9.4z',
    pin: 'M19 10c0 5.5-7 11-7 11s-7-5.5-7-11a7 7 0 0 1 14 0zM12 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
    chat: 'M4.5 19.5l1.3-4A7.5 7.5 0 1 1 8.7 18.3z',
    phone: 'M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4 1.5v3a2 2 0 0 1-2 2A15.5 15.5 0 0 1 4.5 6a2 2 0 0 1 2-2z',
    arrow: 'M5 12h14M13 6l6 6-6 6',
    star: 'M12 2.6l2.85 5.95 6.55.87-4.78 4.55 1.2 6.5L12 17.33 6.18 20.47l1.2-6.5L2.6 9.42l6.55-.87z'
  };

  const LOCAL = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
  const linkBase = String(LINK || (LOCAL && typeof window.CD_LINK === 'string' ? window.CD_LINK : '')).replace(/\/+$/, '');
  const cleanFetch = typeof window.cityDoctorBookingFetch === 'function' ? window.cityDoctorBookingFetch : window.fetch.bind(window);
  const script = document.currentScript;
  const rootUrl = String((script && script.dataset.root) || (window.cdI18n && window.cdI18n.root) || '/').replace(/\/+$/, '');
  const viewUrl = view => rootUrl + '/?view=' + view;

  const mem = new Map();
  const storeOf = name => { try { const s = window[name]; s.setItem('cd-check', '1'); s.removeItem('cd-check'); return s; } catch (e) { return null; } };
  const box = s => ({
    get(key, fallback) { try { const v = JSON.parse(s ? s.getItem(key) : mem.has(key) ? mem.get(key) : 'null'); return v === null || v === undefined ? fallback : v; } catch (e) { return fallback; } },
    set(key, value) { try { if (s) s.setItem(key, JSON.stringify(value)); else mem.set(key, JSON.stringify(value)); } catch (e) {} },
    clear(key) { try { if (s) s.removeItem(key); else mem.delete(key); } catch (e) {} }
  });
  const tabStore = storeOf('sessionStorage'), longStore = storeOf('localStorage');
  const tab = box(tabStore), keep = box(longStore || tabStore);

  const SHA_K = new Uint32Array([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ]);
  function sha256(bytes) {
    const state = new Uint32Array([0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19]);
    const size = bytes.length, total = ((size + 9 + 63) >> 6) << 6, data = new Uint8Array(total), view = new DataView(data.buffer), w = new Uint32Array(64);
    const rot = (x, n) => (x >>> n) | (x << (32 - n));
    data.set(bytes);
    data[size] = 0x80;
    view.setUint32(total - 8, Math.floor(size / 0x20000000));
    view.setUint32(total - 4, (size << 3) >>> 0);
    for (let off = 0; off < total; off += 64) {
      for (let i = 0; i < 16; i++) w[i] = view.getUint32(off + i * 4);
      for (let i = 16; i < 64; i++) {
        const x = w[i - 15], y = w[i - 2];
        w[i] = (w[i - 16] + (rot(x, 7) ^ rot(x, 18) ^ (x >>> 3)) + w[i - 7] + (rot(y, 17) ^ rot(y, 19) ^ (y >>> 10))) >>> 0;
      }
      let a = state[0], b = state[1], c = state[2], d = state[3], e = state[4], f = state[5], g = state[6], p = state[7];
      for (let i = 0; i < 64; i++) {
        const t1 = (p + (rot(e, 6) ^ rot(e, 11) ^ rot(e, 25)) + ((e & f) ^ (~e & g)) + SHA_K[i] + w[i]) >>> 0;
        const t2 = ((rot(a, 2) ^ rot(a, 13) ^ rot(a, 22)) + ((a & b) ^ (a & c) ^ (b & c))) >>> 0;
        p = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
      }
      state[0] += a; state[1] += b; state[2] += c; state[3] += d; state[4] += e; state[5] += f; state[6] += g; state[7] += p;
    }
    const out = new Uint8Array(32), ov = new DataView(out.buffer);
    for (let i = 0; i < 8; i++) ov.setUint32(i * 4, state[i]);
    return out;
  }
  const b64url = bytes => btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const locks = new Map();
  function lockOf(key) {
    if (!locks.has(key)) locks.set(key, b64url(sha256(new TextEncoder().encode(key))));
    return locks.get(key);
  }
  const newKey = () => b64url(crypto.getRandomValues(new Uint8Array(18)));
  function newRef(taken) {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let tries = 0; tries < 50; tries++) {
      let out = '';
      while (out.length < 8) for (const b of crypto.getRandomValues(new Uint8Array(16))) if (b < 252 && out.length < 8) out += letters[b % 36];
      if (!taken.includes('CD-' + out)) return 'CD-' + out;
    }
    return '';
  }

  const dubai = ms => new Date(ms + 4 * HOUR);
  const slotStart = (day, hour) => Date.parse(day + 'T' + String(hour).padStart(2, '0') + ':00:00+04:00');
  const slotIso = ms => dubai(ms).toISOString().slice(0, 19) + '+04:00';
  function consoleDate(ms) {
    const d = dubai(ms), hour = d.getUTCHours();
    return MONTHS_EN[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear() + ', ' + (hour % 12 || 12) + ':' + String(d.getUTCMinutes()).padStart(2, '0') + ' ' + (hour < 12 ? 'AM' : 'PM');
  }
  function fullPhone(raw) {
    const text = String(raw || '').trim().replace(/\(\s*0\s*\)/g, '');
    let d = text.replace(/\D/g, '');
    if (!text.startsWith('+')) {
      if (d.startsWith('00')) { d = d.slice(2); if (/^0?5\d{8}$/.test(d)) return ''; }
      else if (/^05\d{8}$/.test(d)) d = '971' + d.slice(1);
      else if (/^5\d{8}$/.test(d)) d = '971' + d;
      else if (!/^(?:971|966)0?5\d{8}$/.test(d)) return '';
    }
    d = d.replace(/^(971|966)0(?=5)/, '$1');
    if (/^9665/.test(d) && d.length !== 12) return '';
    if (d.startsWith('971') && !/^971(?:5\d{8}|[234679]\d{7})$/.test(d)) return '';
    return /^[1-9]\d{7,14}$/.test(d) ? '+' + d : '';
  }
  function dubaiBounds(now) {
    const at = now === undefined ? Date.now() : now, first = Math.ceil((at + HOUR) / HOUR) * HOUR;
    return { first, today: dubai(at).toISOString().slice(0, 10), minDay: dubai(first).toISOString().slice(0, 10) };
  }
  const addDays = (day, n) => new Date(Date.parse(day + 'T00:00:00Z') + n * DAY).toISOString().slice(0, 10);
  const freeSlots = day => { const b = dubaiBounds(); return Array.from({ length: 24 }, (x, hour) => hour).filter(hour => slotStart(day, hour) >= b.first); };
  const fill = (text, map) => String(text).replace(/\{(\w+)\}/g, (all, name) => (Object.prototype.hasOwnProperty.call(map, name) ? String(map[name]) : all));
  function shortDate(day) {
    const d = new Date(day + 'T12:00:00Z');
    return W.days.split(',')[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + W.months.split(',')[d.getUTCMonth()];
  }
  const hourName = n => { const hour = n % 24; return hour === 0 ? W.midnight : hour === 12 ? W.noon : (hour % 12) + ' ' + (hour < 12 ? W.am : W.pm); };
  function slotLabel(hour) {
    const a = hour % 24, b = (hour + 1) % 24;
    if (a === 11 || a === 23 || a === 0 || a === 12) return hourName(a) + ' ' + W.to + ' ' + hourName(b).toLowerCase();
    return (a % 12) + ' ' + W.to + ' ' + hourName(b);
  }
  function clock(iso) {
    const t = typeof iso === 'string' ? Date.parse(iso) : NaN;
    if (!Number.isFinite(t)) return '';
    const d = dubai(t), hour = d.getUTCHours();
    return (hour % 12 || 12) + ':' + String(d.getUTCMinutes()).padStart(2, '0') + ' ' + (hour < 12 ? W.am : W.pm);
  }
  function windowLine(w) {
    if (!w || typeof w !== 'object' || typeof w.date !== 'string' || !DAY_RE.test(w.date) || !Number.isFinite(Date.parse(w.date + 'T12:00:00Z'))) return '';
    const good = t => (typeof t === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(t) ? t : '');
    const a = good(w.start), b = good(w.end);
    if (!a) return shortDate(w.date);
    const whole = a.endsWith(':00') && b && b.endsWith(':00') && (Number(a.slice(0, 2)) + 1) % 24 === Number(b.slice(0, 2));
    const one = t => clock(w.date + 'T' + t + ':00+04:00');
    return shortDate(w.date) + W.sep + (whole ? slotLabel(Number(a.slice(0, 2))) : b ? one(a) + ' ' + W.to + ' ' + one(b) : one(a));
  }
  const whenLine = n => shortDate(n.day) + W.sep + slotLabel(n.time);
  const whenOf = ms => shortDate(dubai(ms).toISOString().slice(0, 10)) + W.sep + slotLabel(dubai(ms).getUTCHours());

  const visitEnd = n => slotStart(n.day, n.time) + HOUR;
  const goodNote = n => !!n && typeof n === 'object' && typeof n.ref === 'string' && REF_RE.test(n.ref) && typeof n.key === 'string' && KEY_RE.test(n.key) && typeof n.uid === 'string' && n.uid.length > 0 && n.uid.length <= 80
    && typeof n.day === 'string' && DAY_RE.test(n.day) && Number.isInteger(n.time) && n.time >= 0 && n.time < 24 && Number.isFinite(visitEnd(n)) && (n.state === 'sent' || n.state === 'booked') && Number.isFinite(n.at) && (n.cart === undefined || (typeof n.cart === 'string' && n.cart.length <= 12));
  const aliveNote = (n, now) => (n.state === 'sent' ? (now || Date.now()) - n.at < SENT_DAYS * DAY : (now || Date.now()) < visitEnd(n) + BOOKED_DAYS * DAY);
  function notes() {
    const raw = keep.get(NOTES, null);
    if (raw === null) return [];
    const list = (Array.isArray(raw) ? raw : []).filter(n => goodNote(n) && aliveNote(n)).slice(0, MAX_NOTES);
    if (!Array.isArray(raw) || list.length !== raw.length) { if (list.length) keep.set(NOTES, list); else keep.clear(NOTES); }
    return list;
  }
  function saveNotes(list) {
    const now = Date.now(), ahead = n => visitEnd(n) > now, booked = list.filter(n => n.state === 'booked');
    const kept = [
      ...list.filter(n => n.state === 'sent').sort((a, b) => b.at - a.at).slice(0, MAX_SENT),
      ...booked.filter(ahead).sort((a, b) => visitEnd(a) - visitEnd(b)),
      ...booked.filter(n => !ahead(n)).sort((a, b) => visitEnd(b) - visitEnd(a))
    ].slice(0, MAX_NOTES);
    if (kept.length) keep.set(NOTES, kept); else keep.clear(NOTES);
  }
  const bookedNotes = () => notes().filter(n => n.state === 'booked');
  function changeNote(ref, change) {
    const list = notes(), n = list.find(x => x.ref === ref);
    if (n) { Object.assign(n, change); saveNotes(list); }
    return n || null;
  }
  const noteBooked = ref => changeNote(ref, { state: 'booked', at: Date.now() });
  function claimPaid() {
    const raw = keep.get(PAID, null);
    if (raw === null) return null;
    keep.clear(PAID);
    const words = (Array.isArray(raw) ? raw : [raw]).filter(w => w && typeof w === 'object' && typeof w.ref === 'string' && REF_RE.test(w.ref));
    const stored = keep.get(NOTES, null), all = (Array.isArray(stored) ? stored : []).filter(goodNote);
    let got = null;
    for (const n of all) {
      if (n.state !== 'sent') continue;
      if (!words.some(w => w.ref === n.ref && (aliveNote(n) || (Number.isFinite(w.at) && w.at >= n.at && w.at - n.at < SENT_DAYS * DAY)))) continue;
      n.state = 'booked';
      n.at = Date.now();
      got = got || n;
    }
    if (!got) return null;
    saveNotes(all.filter(n => aliveNote(n)));
    return aliveNote(got) ? got : null;
  }
  function nextNote(list) {
    const now = Date.now(), ahead = list.filter(n => visitEnd(n) > now).sort((a, b) => visitEnd(a) - visitEnd(b));
    return ahead[0] || [...list].sort((a, b) => visitEnd(b) - visitEnd(a))[0] || null;
  }
  const unseenNote = () => bookedNotes().find(n => !n.seen && Date.now() < visitEnd(n)) || null;

  let waSeen = false;
  const chosen = new Map();
  function cartMark() {
    let token = '';
    try { const m = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie); token = m ? m[1] : ''; } catch (e) { token = ''; }
    if (!token) return '';
    let mark = 2166136261;
    for (const ch of token) mark = Math.imul(mark ^ ch.codePointAt(0), 16777619);
    return (mark >>> 0).toString(36);
  }
  function noteFor(uid, day, hour) {
    claimPaid();
    const list = notes(), now = Date.now(), mark = cartMark();
    let n = chosen.has(uid) ? list.find(x => x.ref === chosen.get(uid) && x.uid === uid && x.state === 'sent') : list.find(x => x.uid === uid && x.state === 'sent' && x.cart === mark);
    if (n) {
      if (n.day !== day || n.time !== hour || now - n.at > 60000) { n.day = day; n.time = hour; n.at = now; saveNotes(list); }
    } else {
      const ref = newRef(list.map(x => x.ref));
      if (!ref) return null;
      n = { uid, ref, key: newKey(), day, time: hour, cart: mark, state: 'sent', at: now };
      saveNotes([n, ...list]);
    }
    chosen.set(uid, n.ref);
    return n;
  }
  function lines(props, day, time, phone) {
    try {
      const uid = props && props._citydoctor_booking;
      if (typeof uid !== 'string' || !uid || uid.length > 80) return props;
      if (typeof day !== 'string' || !DAY_RE.test(day) || typeof time !== 'string' || !/^([01]\d|2[0-3]):00$/.test(time)) return props;
      const hour = Number(time.slice(0, 2)), start = slotStart(day, hour);
      if (!Number.isFinite(start)) return props;
      const n = noteFor(uid, day, hour);
      if (!n) return props;
      const out = Object.assign({}, props, { 'Booking reference': n.ref, Date: consoleDate(start), _booking_lock: lockOf(n.key), _slot_start: slotIso(start), _slot_end: slotIso(start + HOUR) });
      const full = fullPhone(phone);
      if (full) out._phone = full;
      if (WA_LINE && waSeen) out._whatsapp_booking_updates = 'yes';
      out._site = SITE;
      return out;
    } catch (e) { return props; }
  }
  window.cdAfterLines = lines;

  const $ = (sel, from) => (from || document).querySelector(sel);
  const $$ = (sel, from) => [...(from || document).querySelectorAll(sel)];
  function add(el, kids) {
    for (const kid of kids) {
      if (Array.isArray(kid)) add(el, kid);
      else if (kid === null || kid === undefined || kid === false || kid === '') continue;
      else el.append(kid instanceof Node ? kid : document.createTextNode(String(kid)));
    }
  }
  function h(tag, attrs, ...kids) {
    const el = document.createElement(tag);
    if (attrs) for (const name of Object.keys(attrs)) {
      const value = attrs[name];
      if (value === false || value === null || value === undefined) continue;
      el.setAttribute(name, value === true ? '' : String(value));
    }
    add(el, kids);
    return el;
  }
  function icon(name) {
    const NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'), path = document.createElementNS(NS, 'path');
    svg.setAttribute('class', 'cda-ic cda-ic--' + name);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    path.setAttribute('d', ICON[name]);
    svg.append(path);
    return svg;
  }

  let root = null, screen = '', sample = false;
  let sampleStep = 0, sampleStars = 0, sampleCase = '', sampleAsk = null, sampleWords = false;
  let askPanel = null, fbSent = false, starTimer = 0, seenTimer = 0, seenRef = '', toastTimer = 0, drawnMark = '', heldKey = '';
  const linked = { key: '', answer: null, at: 0, state: '', busy: false, fails: 0, timer: 0, stale: 0, seq: 0, wrote: 0, next: false };

  const waUrl = text => 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(text);
  const waBooking = ref => waUrl(fill(W.waHello, { code: ref }));
  const helpButtons = ref => h('div', { class: 'cda-actions' },
    h('a', { class: 'cda-btn cda-btn--line', href: ref ? waBooking(ref) : waUrl(W.waHelp), target: '_blank', rel: 'noopener' }, icon('chat'), W.wa),
    h('a', { class: 'cda-btn cda-btn--line', href: TEL }, icon('phone'), fill(W.call, { phone: PHONE_LABEL })));
  const fine = () => h('p', { class: 'cda-fine' }, W.emergency + ' ', h('a', { href: 'tel:998' }, '998'), '.');
  const copyButton = ref => h('button', { class: 'cda-btn cda-btn--xs', type: 'button', 'data-action': 'copy-code', 'data-code': ref, 'aria-label': fill(W.copyAria, { code: ref }) }, W.copy);
  const factRow = (title, body, more) => h('div', { class: 'cda-row' }, h('div', null, h('small', null, title), h('p', null, body)), more);
  const card = (id, ic, title, extra, ...kids) => h('section', { class: 'cda-card' + (extra ? ' ' + extra : ''), 'aria-labelledby': id }, h('h2', { class: 'cda-card-title', id }, icon(ic), title), kids);
  const sampleStrip = more => h('div', { class: 'cda-sample', role: 'note' }, h('p', null, h('strong', null, W.sampleStrong), ' ' + W.sampleRest), more);
  const codeLine = (lead, ref) => h('p', { class: 'cda-count' }, lead + ' ', h('strong', { class: 'cda-code' }, ref));
  const title = text => h('h1', { class: 'cda-h1', id: 'cdaTitle', tabindex: -1 }, text);
  const sampleNote = () => ({ ref: SAMPLE_REF, day: addDays(dubaiBounds().today, 1), time: 18, state: 'booked', sample: true });

  function bookedPage(n) {
    return {
      title: W.bookedTitle,
      band: [h('p', { class: 'cda-hi' }, icon('check'), W.thanks), title(W.bookedTitle), codeLine(W.yourCode, n.ref)],
      page: [
        n.sample ? sampleStrip() : null,
        card('cdaVisitTitle', 'calendar', W.visit, '',
          factRow(W.timeAsked, [whenLine(n) + ' ', h('span', { class: 'cda-muted' }, W.dubai)]),
          factRow(W.code, h('span', { class: 'cda-code' }, n.ref), copyButton(n.ref))),
        card('cdaNextTitle', 'heart', W.next, '', h('ol', { class: 'cda-how' }, [W.next1, W.next2, W.next3].map(t => h('li', null, t)))),
        h('div', { class: 'cda-actions' },
          h('a', { class: 'cda-btn cda-btn--main', href: viewUrl(n.sample ? 'cd-track-sample' : 'cd-track'), 'data-action': n.sample ? false : 'open-track', 'data-ref': n.sample ? false : n.ref }, h('span', null, icon('pin'), W.trackTitle), icon('arrow')),
          h('a', { class: 'cda-btn cda-btn--line', href: waBooking(n.ref), target: '_blank', rel: 'noopener' }, icon('chat'), W.wa),
          h('a', { class: 'cda-btn cda-btn--line', href: TEL }, icon('phone'), fill(W.call, { phone: PHONE_LABEL }))),
        fine()
      ]
    };
  }

  function feedbackCard(f) {
    const stars = Number.isInteger(f.stars) && f.stars >= 1 && f.stars <= 5 ? f.stars : 0;
    return card('cdaFbTitle', 'heart', W.fbTitle, 'cda-fb',
      h('fieldset', { class: 'cda-stars' }, h('legend', { class: 'cda-sr' }, W.fbLegend),
        [1, 2, 3, 4, 5].map(n => h('label', { class: 'cda-star' + (n <= stars ? ' is-on' : '') },
          h('input', { type: 'radio', name: 'cda-stars', value: n, autocomplete: 'off', checked: n === stars }),
          h('span', { class: 'cda-sr' }, n === 1 ? W.star1 : fill(W.starN, { n })), icon('star')))),
      h('p', { class: 'cda-fb-said', role: 'status' }, f.words ? W.fbThanksWords : stars ? W.fbThanks : W.fbTap),
      f.words ? null : h('div', { class: 'cda-field cda-fb-more', hidden: !stars },
        h('label', { for: 'cdaFbWords' }, W.fbMore + ' ', h('small', null, W.fbMoreOpt)),
        h('textarea', { id: 'cdaFbWords', rows: 3, maxlength: 500, autocomplete: 'off', placeholder: W.fbPlaceholder }),
        h('button', { class: 'cda-btn cda-btn--dark', type: 'button', 'data-action': 'feedback-send' }, W.send)),
      h('a', { class: 'cda-btn cda-btn--line', href: GOOGLE_REVIEW, target: '_blank', rel: 'noopener' }, W.google));
  }

  const goodAnswer = m => !!m && typeof m === 'object' && m.v === 2 && m.brand === BRAND && m.kind === 'visit' && typeof m.status === 'string' && (STEPS.includes(m.status) || m.status === 'cancelled');
  function trackerParts(m, opt) {
    const live = !opt || opt.live !== false, sent = !!(opt && opt.sent);
    const askUs = () => ({ top: h('div', { class: 'cda-trk cda-trk--still' }, h('h2', { class: 'cda-trk-now' }, W.askUsNow), h('p', { class: 'cda-trk-sub' }, W.askUsSub)), steps: null, feedback: null, plain: false, none: true });
    if (!goodAnswer(m) || !STEPS.includes(m.status)) return askUs();
    const steps = STEPS.filter(s => Array.isArray(m.steps) && m.steps.includes(s)), at = steps.indexOf(m.status);
    if (at < 0) return askUs();
    if (steps.length < 2) return { top: h('div', { class: 'cda-trk cda-trk--still' }, h('h2', { class: 'cda-trk-now' }, W.now_received), h('p', { class: 'cda-trk-sub' }, W.waPromise)), steps: null, feedback: null, plain: true, none: false };
    const reached = new Map();
    for (const e of Array.isArray(m.events) ? m.events : []) if (e && typeof e === 'object' && typeof e.status === 'string' && STEPS.includes(e.status)) reached.set(e.status, clock(e.at));
    const fb = m.feedback && typeof m.feedback === 'object' ? m.feedback : {};
    const over = m.status === 'done', quiet = m.quiet === true && !over, asks = over && fb.ask === true, moving = live && !quiet && !over;
    const label = over ? W.visitDone : moving ? W.live : '';
    const now = quiet ? W.passedNow : W['now_' + m.status], sub = quiet ? W.passedSub : over && !asks ? W.doneSub : W['sub_' + m.status];
    return {
      top: h('div', { class: 'cda-trk' + (moving || over ? '' : ' cda-trk--still') },
        label ? h('p', { class: 'cda-trk-label' }, moving ? h('span', { class: 'cda-live', 'aria-hidden': 'true' }) : null, label) : null,
        h('h2', { class: 'cda-trk-now' }, now),
        h('p', { class: 'cda-trk-sub' }, sub),
        h('div', { class: 'cda-trk-bar', 'aria-hidden': 'true' }, steps.map((s, i) => h('span', { class: i < at || over ? 'is-on' : i === at ? 'is-now' : false })))),
      steps: card('cdaStepsTitle', 'clock', W.stepsTitle, '',
        h('ol', { class: 'cda-steps' + (moving ? '' : ' cda-steps--still') }, steps.map((s, i) => {
          const done = i < at || over, time = i <= at && reached.get(s) ? reached.get(s) : '';
          return h('li', { class: (done ? 'is-done' : i === at ? 'is-now' : 'is-next') + (i === at - 1 && !over ? ' is-fresh' : ''), 'aria-current': i === at && !over ? 'step' : false },
            h('span', { class: 'cda-dot', 'aria-hidden': 'true' }, done ? icon('check') : null),
            h('span', { class: 'cda-name' }, W['step_' + s], h('span', { class: 'cda-sr' }, ' ' + (done ? W.srDone : i === at ? W.srNow : W.srNext))),
            time ? h('time', null, time) : null);
        }))),
      feedback: asks ? feedbackCard({ stars: fb.stars, words: fb.said === true && sent }) : null,
      plain: false, none: false
    };
  }

  const askDays = () => { const b = dubaiBounds(); return Array.from({ length: 7 }, (x, i) => addDays(b.minDay, i)); };
  function hourOptions(day, picked) {
    const free = freeSlots(day), want = Number(picked), mine = free.includes(want) ? want : free.includes(17) ? 17 : free[0];
    return free.map(hour => h('option', { value: hour, selected: hour === mine }, slotLabel(hour)));
  }
  function askPart(m) {
    const a = m.ask && typeof m.ask === 'object' ? m.ask : {}, open = a.open && typeof a.open === 'object' ? a.open : null;
    if (open) {
      const start = typeof open.start === 'string' ? Date.parse(open.start) : NaN, time = open.kind !== 'cancel';
      const when = time && Number.isFinite(start) ? whenOf(start) : '';
      return h('div', { class: 'cda-ask cda-ask--sent', role: 'status' },
        h('h3', { id: 'cdaAskTitle', tabindex: -1 }, icon('check'), open.seen === true ? W.askSeen : W.askGot),
        h('p', null, when ? [W.askedFor + ' ', h('strong', null, when), '.'] : time ? W.askedTime : W.askedCancel),
        h('p', { class: 'cda-line' }, time ? W.keepsTimeWa : W.staysWa),
        h('div', { class: 'cda-ask-actions' }, h('button', { class: 'cda-btn cda-btn--quiet', type: 'button', 'data-action': 'ask-undo' }, W.askUndo)));
    }
    if (a.can !== true) {
      askPanel = null;
      const out = a.last && typeof a.last === 'object' && typeof a.last.outcome === 'string' ? a.last.outcome : '';
      const ended = out === 'declined' ? W.askDeclined : out === 'too_late' ? W.askTooLate : '';
      if (ended) return h('p', { class: 'cda-line' }, ended);
      return m.status === 'done' || m.status === 'cancelled' || STEPS.indexOf(m.status) <= 1 ? null : h('p', { class: 'cda-line' }, W.changeNow);
    }
    if (askPanel === 'time') {
      const days = askDays();
      return h('div', { class: 'cda-ask', role: 'group', 'aria-labelledby': 'cdaAskTitle' },
        h('h3', { id: 'cdaAskTitle', tabindex: -1 }, W.askTime),
        h('div', { class: 'cda-field' }, h('label', { for: 'cdaAskDay' }, W.day), h('select', { id: 'cdaAskDay' }, days.map(d => h('option', { value: d }, shortDate(d))))),
        h('div', { class: 'cda-field' }, h('label', { for: 'cdaAskHour' }, W.time + ' ', h('small', null, W.dubaiPar)), h('select', { id: 'cdaAskHour' }, hourOptions(days[0], 17))),
        h('p', { class: 'cda-line' }, W.keepsTime),
        h('div', { class: 'cda-ask-actions' },
          h('button', { class: 'cda-btn cda-btn--dark', type: 'button', 'data-action': 'ask-send' }, W.askSend),
          h('button', { class: 'cda-btn cda-btn--quiet', type: 'button', 'data-action': 'ask-back' }, W.back)));
    }
    if (askPanel === 'cancel') {
      return h('div', { class: 'cda-ask', role: 'group', 'aria-labelledby': 'cdaAskTitle' },
        h('h3', { id: 'cdaAskTitle', tabindex: -1 }, W.cancelTitle),
        h('p', { class: 'cda-line' }, W.cancelLine),
        h('div', { class: 'cda-ask-actions' },
          h('button', { class: 'cda-btn cda-btn--dark', type: 'button', 'data-action': 'ask-send' }, W.cancelYes),
          h('button', { class: 'cda-btn cda-btn--line', type: 'button', 'data-action': 'ask-back' }, W.cancelNo)));
    }
    return h('div', { class: 'cda-ask-actions' },
      h('button', { class: 'cda-btn cda-btn--line', type: 'button', 'data-action': 'ask-open', 'data-ask': 'time', 'data-focus': 'ask-time' }, W.askTime),
      h('button', { class: 'cda-btn cda-btn--quiet', type: 'button', 'data-action': 'ask-open', 'data-ask': 'cancel', 'data-focus': 'ask-cancel' }, W.askCancel));
  }
  function movedCard(m) {
    const w = m.window;
    if (!w || typeof w !== 'object' || w.state !== 'moved') return null;
    const late = w.reason === 'late', was = w.was && typeof w.was === 'object' ? windowLine(w.was) : '';
    return card('cdaMovedTitle', 'clock', late ? W.lateTitle : W.movedTitle, 'cda-moved',
      factRow(W.newTime, [h('strong', null, windowLine(w)), ' ', h('span', { class: 'cda-muted' }, W.dubai)], h('em', { class: 'cda-tag cda-tag--new' }, W.tagNew)),
      was ? factRow(W.timeBefore, h('s', null, was)) : null,
      h('p', { class: 'cda-line' }, (late ? W.sorryWait : W.sorryChange) + ' ' + W.tellUs));
  }
  function visitCard(m, ref) {
    const w = m.window && typeof m.window === 'object' ? m.window : null, when = w ? windowLine(w) : '';
    const team = (Array.isArray(m.team) ? m.team : []).filter(x => x && typeof x === 'object' && typeof x.firstName === 'string' && x.firstName).slice(0, 4)
      .map(x => x.firstName.slice(0, 40) + (typeof x.role === 'string' && x.role ? W.sep + x.role.slice(0, 40) : '')).join(' ' + W.and + ' ');
    const timeName = w && w.state === 'moved' ? W.timeNew : w && w.state === 'confirmed' ? W.timeYours : W.timeAsked;
    const tag = w && w.state === 'confirmed' ? h('em', { class: 'cda-tag' }, W.confirmed) : w && w.state === 'moved' ? h('em', { class: 'cda-tag cda-tag--new' }, W.tagNew) : null;
    return card('cdaVisitTitle', 'calendar', W.visit, '',
      when ? factRow(timeName, [when + ' ', h('span', { class: 'cda-muted' }, W.dubai)], tag) : null,
      team ? factRow(W.team, team) : null,
      factRow(W.code, h('span', { class: 'cda-code' }, ref), copyButton(ref)),
      askPart(m));
  }

  function trackSample() {
    const day = addDays(dubaiBounds().today, 1), stamp = (hour, min) => day + 'T' + String(hour).padStart(2, '0') + ':' + String(min).padStart(2, '0') + ':00+04:00';
    const times = [stamp(15, 2), stamp(15, 9), stamp(17, 41), stamp(17, 59), stamp(18, 4), stamp(18, 52)];
    const moved = sampleCase && sampleStep < 4 ? sampleCase : '';
    const m = {
      v: 2, brand: BRAND, kind: 'visit', ref: SAMPLE_REF, status: STEPS[sampleStep], steps: STEPS,
      window: moved ? { date: day, start: '19:00', end: '20:00', tz: 'Asia/Dubai', state: 'moved', reason: moved, was: { date: day, start: '18:00', end: '19:00' } }
        : { date: day, start: '18:00', end: '19:00', tz: 'Asia/Dubai', state: sampleStep ? 'confirmed' : 'requested' },
      team: sampleStep ? [{ role: W.sampleNurse, firstName: W.sampleName }] : [],
      events: STEPS.slice(0, sampleStep + 1).map((s, i) => ({ status: s, at: times[i] })),
      feedback: { ask: true, stars: sampleStars || null, said: sampleWords },
      ask: { can: sampleStep <= 1 && !sampleAsk, open: sampleStep <= 1 && sampleAsk ? sampleAsk : null, last: null }
    };
    const t = trackerParts(m, { sent: sampleWords });
    const nav = h('div', { class: 'cda-sample-nav' },
      h('button', { class: 'cda-btn cda-btn--sm', type: 'button', 'data-action': 'sample-step', 'data-step': -1, 'data-focus': 'sample-back', disabled: sampleStep === 0 }, W.sampleEarlier),
      h('span', null, fill(W.sampleStep, { n: sampleStep + 1, all: STEPS.length })),
      h('button', { class: 'cda-btn cda-btn--sm', type: 'button', 'data-action': 'sample-step', 'data-step': 1, 'data-focus': 'sample-next', disabled: sampleStep === STEPS.length - 1 }, W.sampleNext));
    const cases = sampleStep < 4 ? h('div', { class: 'cda-sample-cases', role: 'group', 'aria-label': W.sampleCases },
      [['', W.caseOnTime], ['moved', W.caseMoved], ['late', W.caseLate]].map(pair => h('button', { class: 'cda-btn cda-btn--sm', type: 'button', 'data-action': 'sample-case', 'data-case': pair[0], 'data-focus': 'case-' + (pair[0] || 'plain'), 'aria-pressed': sampleCase === pair[0] ? 'true' : 'false' }, pair[1]))) : null;
    return {
      title: W.trackTitle,
      band: [title(W.trackTitle), codeLine(W.code, SAMPLE_REF), t.top],
      page: [sampleStrip([nav, cases]), movedCard(m), t.feedback, t.steps, visitCard(m, SAMPLE_REF), helpButtons(SAMPLE_REF), fine()]
    };
  }

  const linkOn = () => !!linkBase;
  const linkFresh = () => linked.state === 'ok' && performance.now() - linked.at < 60000;
  const onLive = () => !!root && screen === 'track' && !sample;
  async function linkCall(path, body) {
    const stop = new AbortController(), timer = setTimeout(() => stop.abort(), 8000);
    try {
      const res = await cleanFetch(linkBase + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: stop.signal, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer' });
      let json = null;
      try { json = await res.json(); } catch (e) { json = null; }
      return { status: res.status, json };
    } catch (e) { return null; } finally { clearTimeout(timer); }
  }
  function linkTake(key, res, read) {
    if (linked.key !== key) return false;
    if (res && res.status === 200 && goodAnswer(res.json)) {
      Object.assign(linked, { answer: res.json, at: performance.now(), state: 'ok', fails: 0 });
      const waiting = notes().find(n => n.key === key && n.state === 'sent');
      if (waiting && res.json.ref === waiting.ref) noteBooked(waiting.ref);
      return true;
    }
    if (!read) return false;
    if (res && res.status === 404) Object.assign(linked, { answer: null, state: 'missing' }); else linked.state = 'silent';
    linked.fails++;
    return false;
  }
  async function askLink(key) {
    if (!linkOn() || typeof key !== 'string' || !KEY_RE.test(key)) return;
    if (linked.key !== key) { clearTimeout(linked.timer); Object.assign(linked, { key, answer: null, at: 0, state: '', fails: 0, next: false }); askPanel = null; fbSent = false; }
    if (linked.busy) return;
    linked.busy = true;
    const seq = ++linked.seq, res = await linkCall('/v1/visit', { key });
    linked.busy = false;
    if (linked.key !== key) { askLink(linked.key); return; }
    if (seq > linked.wrote) linkTake(key, res, true);
    if (onLive()) redraw();
    clearTimeout(linked.timer);
    const said = linked.state === 'ok' ? Number(linked.answer.nextPollSeconds) : NaN;
    const again = linked.state === 'ok' ? (Number.isFinite(said) && said > 0 ? Math.min(3600, Math.max(5, said)) : 0) : Math.min(300, 15 * Math.pow(2, Math.min(linked.fails, 5)));
    linked.next = again > 0;
    if (again > 0) linked.timer = setTimeout(() => { linked.next = false; if (onLive() && document.visibilityState === 'visible') askLink(key); }, again * 1000);
  }
  let sentAsking = false;
  async function askForSent() {
    if (!linkOn() || sentAsking || sample) return;
    const waiting = notes().filter(n => n.state === 'sent');
    if (!waiting.length) return;
    const last = Number(tab.get(ASKED, 0));
    if (Number.isFinite(last) && last > 0 && Date.now() - last < 20000 && Date.now() >= last) return;
    tab.set(ASKED, Date.now());
    sentAsking = true;
    let changed = false;
    for (const n of waiting) {
      const res = await linkCall('/v1/visit', { key: n.key });
      if (res && res.status === 200 && goodAnswer(res.json) && res.json.ref === n.ref && notes().some(x => x.ref === n.ref && x.state === 'sent')) { noteBooked(n.ref); changed = true; }
    }
    sentAsking = false;
    if (changed) noticed(true);
  }
  async function sendAsk(body) {
    const key = linked.key;
    linked.wrote = ++linked.seq;
    const res = await linkCall('/v1/visit/ask', Object.assign({ key }, body));
    if (linkTake(key, res, false)) return true;
    toast(res && res.status === 409 ? W.askClosed : res && res.status === 422 ? W.askAhead : W.sendFail, 4200);
    return false;
  }
  async function sendFeedback(stars, words) {
    const key = linked.key;
    linked.wrote = ++linked.seq;
    const res = await linkCall('/v1/visit/feedback', Object.assign({ key, stars }, words ? { words } : {}));
    if (linkTake(key, res, false)) return true;
    toast(res && res.status === 409 ? W.fbAlready : W.sendFail, 4200);
    return false;
  }

  function trackTarget() {
    const list = bookedNotes(), pick = tab.get(PICK, ''), stored = tab.get(TRACK_KEY, ''), key = typeof stored === 'string' && KEY_RE.test(stored) ? stored : heldKey;
    if (typeof pick === 'string' && REF_RE.test(pick)) { const n = list.find(x => x.ref === pick); if (n) return { n, key: n.key }; tab.clear(PICK); }
    if (KEY_RE.test(key)) { const n = list.find(x => x.key === key) || null; if (n || linkOn()) return { n, key }; }
    const n = nextNote(list);
    return { n, key: n ? n.key : '' };
  }
  function otherBookings(list, heading) {
    if (!list.length) return null;
    return h('section', { class: 'cda-others', 'aria-labelledby': 'cdaOthersTitle' }, h('h2', { class: 'cda-label', id: 'cdaOthersTitle' }, heading),
      h('ul', { class: 'cda-rows' }, list.map(x => h('li', null, h('button', { type: 'button', 'data-action': 'pick', 'data-ref': x.ref }, h('span', null, h('strong', null, whenLine(x)), h('small', null, W.code + ' ' + x.ref)), icon('arrow'))))));
  }
  const noteBox = (...kids) => h('section', { class: 'cda-card cda-card--note', role: 'status' }, kids);
  function trackPage(n) {
    if (!n) {
      const list = bookedNotes();
      return {
        title: W.trackTitle,
        band: [title(W.trackTitle), h('p', { class: 'cda-count' }, W.trackSub)],
        page: [noteBox(h('p', null, h('strong', null, list.length ? W.notHere : W.noneSaved)), h('p', { class: 'cda-muted' }, W.checkEmail), h('p', { class: 'cda-muted' }, W.sendCode)), helpButtons(''), otherBookings(list, W.savedTitle)]
      };
    }
    const passed = Date.now() > visitEnd(n);
    return {
      title: W.trackTitle,
      band: [title(W.trackTitle), codeLine(W.code, n.ref), h('div', { class: 'cda-trk cda-trk--still' }, h('h2', { class: 'cda-trk-now' }, passed ? W.passedNow : W.now_received), h('p', { class: 'cda-trk-sub' }, passed ? W.passedSub : W.waPromise))],
      page: [
        card('cdaVisitTitle', 'calendar', W.visit, '',
          factRow(W.timeAsked, [whenLine(n) + ' ', h('span', { class: 'cda-muted' }, W.dubai)]),
          factRow(W.code, h('span', { class: 'cda-code' }, n.ref), copyButton(n.ref))),
        helpButtons(n.ref),
        otherBookings(bookedNotes().filter(x => x.ref !== n.ref), W.othersTitle),
        fine()
      ]
    };
  }
  function trackLinked(n, key) {
    const m = linked.key === key ? linked.answer : null;
    if (!m) {
      if (n) return trackPage(n);
      const mine = linked.key === key, missing = mine && linked.state === 'missing', silent = mine && linked.state === 'silent';
      return {
        title: W.trackTitle,
        band: [title(W.trackTitle), h('p', { class: 'cda-count' }, W.trackSub)],
        page: [
          missing ? noteBox(h('p', null, h('strong', null, W.notFound)), h('p', { class: 'cda-muted' }, W.notFoundSub))
            : noteBox(h('p', null, h('strong', null, silent ? W.cannotShow : W.looking)), silent ? h('p', { class: 'cda-muted' }, W.cannotShowSub) : null),
          helpButtons('')
        ]
      };
    }
    const t = trackerParts(m, { live: linkFresh(), sent: fbSent }), ref = typeof m.ref === 'string' && REF_RE.test(m.ref) ? m.ref : n ? n.ref : '';
    if (t.plain && n) return trackPage(n);
    const shows = !t.plain && !t.none && STEPS.includes(m.status);
    return {
      title: W.trackTitle,
      band: [title(W.trackTitle), ref ? codeLine(W.code, ref) : null, t.top],
      page: [
        shows ? movedCard(m) : null,
        t.feedback,
        t.steps,
        m.status === 'cancelled' || t.none || !ref ? null : visitCard(shows ? m : Object.assign({}, m, { team: [], ask: null }), ref),
        helpButtons(ref),
        otherBookings(bookedNotes().filter(x => x.ref !== ref), W.othersTitle),
        fine()
      ]
    };
  }

  function seenNow(n) {
    clearTimeout(seenTimer);
    seenRef = n && !n.sample && !n.seen ? n.ref : '';
    if (seenRef) seenTimer = setTimeout(() => { if (seenRef && document.visibilityState === 'visible') { changeNote(seenRef, { seen: true }); seenRef = ''; } }, 1200);
  }
  function paint(view) {
    const bandBox = $('[data-cda-band]', root), pageBox = $('[data-cda-page]', root), page = [];
    if (!bandBox || !pageBox) return;
    add({ append: x => page.push(x) }, view.page);
    bandBox.replaceChildren(...view.band.filter(Boolean));
    pageBox.replaceChildren(...page);
    root.setAttribute('data-drawn', 'yes');
    if (view.title) document.title = view.title + ' | ' + W.brand;
  }
  function draw() {
    if (!root) return;
    drawnMark = JSON.stringify(bookedNotes());
    if (screen === 'booked') {
      if (sample) { paint(bookedPage(sampleNote())); return; }
      const list = bookedNotes(), pick = tab.get(PICK, '');
      const n = (typeof pick === 'string' && list.find(x => x.ref === pick)) || [...list].sort((a, b) => b.at - a.at)[0] || null;
      if (!n || Date.now() > visitEnd(n)) { if (n) tab.set(PICK, n.ref); location.replace(viewUrl('cd-track')); return; }
      seenNow(n);
      paint(bookedPage(n));
      return;
    }
    if (sample) { paint(trackSample()); return; }
    const target = trackTarget(), n = target.n, asks = linkOn() && KEY_RE.test(target.key);
    seenNow(n);
    paint(asks ? trackLinked(n, target.key) : trackPage(n));
    if (asks && linked.key !== target.key) askLink(target.key);
    clearTimeout(linked.stale);
    if (asks && linkFresh()) linked.stale = setTimeout(() => { if (onLive() && !linkFresh()) redraw(); }, 60500 - (performance.now() - linked.at));
  }
  function redraw() {
    if (!root) return;
    const el = document.activeElement, inside = !!el && root.contains(el), star = $('input[name="cda-stars"]:checked', root);
    const kept = { day: ($('#cdaAskDay', root) || {}).value, hour: ($('#cdaAskHour', root) || {}).value, words: ($('#cdaFbWords', root) || {}).value, stars: star ? Number(star.value) : 0, id: inside && el.id ? el.id : '', focus: inside ? el.getAttribute('data-focus') || '' : '' };
    draw();
    const day = $('#cdaAskDay', root), hour = $('#cdaAskHour', root), words = $('#cdaFbWords', root);
    if (day && kept.day && [...day.options].some(o => o.value === kept.day)) { day.value = kept.day; if (hour) hour.replaceChildren(...hourOptions(kept.day, kept.hour)); }
    if (words && kept.words) { words.value = kept.words; const more = $('.cda-fb-more', root); if (more) more.hidden = false; }
    if (kept.stars && !$('input[name="cda-stars"]:checked', root)) {
      const pick = $$('input[name="cda-stars"]', root)[kept.stars - 1];
      if (pick) { pick.checked = true; $$('.cda-star', root).forEach((x, i) => x.classList.toggle('is-on', i < kept.stars)); const more = $('.cda-fb-more', root); if (more) more.hidden = false; const said = $('.cda-fb-said', root); if (said) said.textContent = W.fbThanks; }
    }
    const back = kept.id ? document.getElementById(kept.id) : kept.focus ? $$('[data-focus]', root).find(x => x.getAttribute('data-focus') === kept.focus) : null;
    if (back && document.activeElement !== back) back.focus({ preventScroll: true });
  }
  function toast(text, ms) {
    const el = root && $('[data-cda-toast]', root);
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; el.textContent = ''; }, ms || 2600);
  }
  const focusOn = sel => { const el = sel === 'title' ? document.getElementById('cdaTitle') : $$('[data-focus]', root).find(x => x.getAttribute('data-focus') === sel && !x.disabled); if (el) el.focus({ preventScroll: true }); return !!el; };
  const focusId = id => { const el = document.getElementById(id); if (el) el.focus({ preventScroll: true }); };

  function onClick(e) {
    const el = e.target instanceof Element ? e.target.closest('[data-action]') : null;
    if (!el || !root.contains(el)) return;
    const action = el.getAttribute('data-action');
    if (action === 'open-track') { const ref = el.getAttribute('data-ref') || ''; if (REF_RE.test(ref)) tab.set(PICK, ref); return; }
    if (action === 'pick') { const ref = el.getAttribute('data-ref') || ''; if (REF_RE.test(ref)) { tab.set(PICK, ref); askPanel = null; draw(); focusOn('title'); window.scrollTo(0, 0); } return; }
    if (action === 'copy-code') {
      const code = el.getAttribute('data-code') || '', say = ok => toast(ok ? W.copied : fill(W.copyFail, { code }));
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(() => say(true), () => say(false)); else say(false);
      return;
    }
    if (action === 'sample-step') {
      if (!sample) return;
      sampleStep = Math.max(0, Math.min(STEPS.length - 1, sampleStep + (el.getAttribute('data-step') === '1' ? 1 : -1)));
      sampleStars = 0; sampleWords = false; askPanel = null;
      if (sampleStep > 1) sampleAsk = null;
      const want = el.getAttribute('data-focus');
      draw();
      if (!focusOn(want)) focusOn('title');
      return;
    }
    if (action === 'sample-case') {
      if (!sample) return;
      const picked = el.getAttribute('data-case');
      sampleCase = picked === 'moved' || picked === 'late' ? picked : '';
      const want = el.getAttribute('data-focus');
      draw();
      focusOn(want);
      return;
    }
    if (action === 'ask-open') { askPanel = el.getAttribute('data-ask') === 'cancel' ? 'cancel' : 'time'; draw(); focusId('cdaAskTitle'); return; }
    if (action === 'ask-back') { askPanel = null; draw(); focusOn('ask-time'); return; }
    if (action === 'ask-send') {
      const kind = askPanel === 'cancel' ? 'cancel' : 'new_time', day = ($('#cdaAskDay', root) || {}).value || '', hour = Number(($('#cdaAskHour', root) || {}).value);
      if (kind === 'new_time' && !(DAY_RE.test(day) && Number.isInteger(hour) && hour >= 0 && hour < 24)) { toast(W.pickTime); return; }
      const start = kind === 'new_time' ? day + 'T' + String(hour).padStart(2, '0') + ':00:00+04:00' : null;
      if (sample) { sampleAsk = { kind, start, seen: false }; askPanel = null; draw(); focusId('cdaAskTitle'); return; }
      if (!onLive() || !linked.key) return;
      el.disabled = true;
      sendAsk(kind === 'new_time' ? { kind, start } : { kind }).then(ok => { if (ok) askPanel = null; el.disabled = false; if (onLive()) { redraw(); if (ok) focusId('cdaAskTitle'); } });
      return;
    }
    if (action === 'ask-undo') {
      if (sample) { sampleAsk = null; draw(); focusOn('ask-time'); return; }
      if (!onLive() || !linked.key) return;
      el.disabled = true;
      sendAsk({ kind: 'none' }).then(ok => { el.disabled = false; if (onLive()) { redraw(); if (ok) focusOn('ask-time'); } });
      return;
    }
    if (action === 'feedback-send') {
      const box = $('#cdaFbWords', root), words = ((box && box.value) || '').trim().slice(0, 500), star = $('input[name="cda-stars"]:checked', root), stars = star ? Number(star.value) : NaN;
      if (sample) { sampleWords = true; draw(); return; }
      if (!onLive() || !linked.key || !Number.isInteger(stars) || stars < 1 || stars > 5) return;
      clearTimeout(starTimer);
      el.disabled = true;
      sendFeedback(stars, words).then(ok => { el.disabled = false; if (ok) { fbSent = true; const now = $('#cdaFbWords', root); if (now) now.value = ''; } if (onLive()) redraw(); });
    }
  }
  function onChange(e) {
    const t = e.target;
    if (!(t instanceof Element) || !root.contains(t)) return;
    if (t.matches('input[name="cda-stars"]')) {
      const stars = Number(t.value);
      if (!Number.isInteger(stars) || stars < 1 || stars > 5) return;
      $$('.cda-star', root).forEach((star, i) => star.classList.toggle('is-on', i < stars));
      const said = $('.cda-fb-said', root), more = $('.cda-fb-more', root);
      if (said) said.textContent = W.fbThanks;
      if (more) more.hidden = false;
      if (sample) { sampleStars = stars; return; }
      clearTimeout(starTimer);
      starTimer = setTimeout(() => { if (onLive() && linked.key) sendFeedback(stars, '').then(() => { if (onLive()) redraw(); }); }, 1500);
      return;
    }
    if (t.id === 'cdaAskDay') { const hours = $('#cdaAskHour', root); if (hours && DAY_RE.test(t.value)) hours.replaceChildren(...hourOptions(t.value, hours.value)); }
  }

  function openFresh() {
    if (root || document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) return false;
    const fresh = unseenNote();
    if (!fresh) return false;
    const opened = tab.get(OPENED, []), list = Array.isArray(opened) ? opened : [];
    if (list.includes(fresh.ref)) return false;
    tab.set(OPENED, [...list, fresh.ref].slice(-10));
    tab.set(PICK, fresh.ref);
    location.assign(viewUrl('cd-booked'));
    return true;
  }
  function noticed(changed) {
    const got = claimPaid();
    if (openFresh()) return;
    if (root && !sample && (got || (changed && JSON.stringify(bookedNotes()) !== drawnMark))) redraw();
  }

  function waLineStart() {
    if (!WA_LINE) return;
    const input = document.querySelector('#cdb-root [data-cdb-phone]');
    if (!input || document.getElementById('cdaWaLine')) return;
    waSeen = tab.get(WA_SEEN, '') === 'yes';
    const line = h('p', { class: 'cdb-note cda-wa-line', id: 'cdaWaLine' }, (script && script.dataset.waLine) || W.waLine);
    (input.closest('label') || input).after(line);
    input.setAttribute('aria-describedby', ((input.getAttribute('aria-describedby') || '') + ' cdaWaLine').trim());
    const saw = () => { if (!waSeen && line.getClientRects().length) { const r = line.getBoundingClientRect(); if (r.bottom > 0 && r.top < window.innerHeight) { waSeen = true; tab.set(WA_SEEN, 'yes'); } } };
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => { if (entries.some(x => x.isIntersecting)) saw(); }).observe(line);
    input.addEventListener('focus', saw);
    input.addEventListener('input', saw);
  }

  function takeHeld() {
    if (typeof window.cdAfterTake !== 'function') return;
    try { const k = window.cdAfterTake(); if (typeof k === 'string' && KEY_RE.test(k)) heldKey = k; } catch (e) {}
  }
  function start() {
    takeHeld();
    root = document.querySelector('[data-cd-after]');
    if (root) {
      screen = root.getAttribute('data-screen') === 'booked' ? 'booked' : 'track';
      sample = root.getAttribute('data-sample') === 'true';
      let own = 0;
      try {
        const over = JSON.parse((document.getElementById('cd-after-words') || {}).textContent || '{}');
        if (over && typeof over === 'object') for (const name of Object.keys(W)) if (typeof over[name] === 'string' && over[name]) { W[name] = over[name]; own++; }
      } catch (e) { own = 0; }
      if (!own && getComputedStyle(root).direction === 'rtl') { root.setAttribute('dir', 'ltr'); root.setAttribute('lang', 'en'); }
      root.addEventListener('click', onClick);
      root.addEventListener('change', onChange);
    }
    claimPaid();
    waLineStart();
    if (root) draw(); else openFresh();
    askForSent();
    window.addEventListener('cd:after-key', () => { takeHeld(); if (root && !sample) { askPanel = null; draw(); } });
    window.addEventListener('storage', e => { if (e.key === null || e.key === PAID || e.key === NOTES) noticed(true); });
    window.addEventListener('pageshow', e => { if (!e.persisted) return; noticed(true); askForSent(); });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      noticed(false);
      if (onLive() && linked.key) askLink(linked.key);
      askForSent();
      const shown = seenRef && bookedNotes().find(n => n.ref === seenRef);
      if (shown) seenNow(shown);
    });
    if (LOCAL && window.CD_AFTER_TEST === true) window.cdAfterTest = { STEPS, W, trackerParts, fullPhone, consoleDate, slotIso, slotStart, slotLabel, shortDate, lockOf, notes, goodAnswer, linked, SITE, linkOn };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
